"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const style_1 = require("./style");
function Carousel({ children, howMuchToShow }) {
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const [length, setLength] = (0, react_1.useState)(react_1.default.Children.count(children));
    (0, react_1.useEffect)(() => {
        setLength(react_1.default.Children.count(children));
    }, [children]);
    const handleNext = () => {
        if (currentIndex < length - howMuchToShow) {
            setCurrentIndex((prevState) => prevState + 1);
        }
    };
    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevState) => prevState - 1);
        }
    };
    return (react_1.default.createElement(style_1.CarouselContainer, null,
        react_1.default.createElement(style_1.CarouselWrapper, { id: "carousel" },
            currentIndex > 0 && (react_1.default.createElement(style_1.LeftArrow, { onClick: handlePrevious }, "<")),
            react_1.default.createElement(style_1.CarouselContentWrapper, null,
                react_1.default.createElement(style_1.CarouselContent, { howMuchToShow: howMuchToShow, style: {
                        transform: `translateX(-${currentIndex * (100 / howMuchToShow)}%)`,
                    } }, children)),
            currentIndex < length - howMuchToShow && (react_1.default.createElement(style_1.RightArrow, { onClick: handleNext }, ">")))));
}
exports.default = Carousel;
